export function CopyToClipboard(textToCopy: string): Promise<string>
{
    try
    {
        // navigator clipboard api needs a secure context (https)
        if (navigator.clipboard && window.isSecureContext)
        {
            // console.log("1111111111111");
            return new Promise((res: (message: string) => void, rej: (message: string) => void) => 
            {
                // navigator clipboard api method'
                try
                {
                    navigator.clipboard.writeText(textToCopy);

                    res("Success");
                }
                catch (error)
                {
                    rej("Can not copy to clipboard: " + error.message);
                }
            })
        }
        else
        {
            // console.log("2222222222222");
            // text area method
            let textArea = document.createElement("textarea");
            textArea.value = textToCopy;
            // make the textarea out of viewport
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            return new Promise((res: (message: string) => void, rej: (message: string) => void) =>
            {
                // here the magic happens
                document.execCommand('copy') ? res("Copy to clipboard succeeded") : rej("Copy to clipboard failed");
                textArea.remove();
            });
        }
    }
    catch (error)
    {
        console.error("Can not copy to clipboard: " + error.message);
        return Promise.reject("Can not copy to clipboard: " + error.message);
        // throw new Error("Can not copy to clipboard: " + error.message);
    }
}